import {
  IconSocialDzen16,
  IconSocialDzen24,
  IconSocialFacebook16,
  IconSocialFacebook24,
  IconSocialGoogle16,
  IconSocialGoogle24,
  IconSocialInstagram16,
  IconSocialInstagram24,
  IconSocialMax16,
  IconSocialMax24,
  IconSocialOK16,
  IconSocialOK24,
  IconSocialTelegram16,
  IconSocialTelegram24,
  IconSocialVK16,
  IconSocialVK24,
  IconSocialVKVideo16,
  IconSocialVKVideo24,
  IconSocialYoutube16,
  IconSocialYoutube24,
} from '@cian/ui-kit-design-tokens/icons';

import type { TSocialId, TSocialIconComponent } from 'shared/types/socials';

export const SOCIAL_ICON_BY_ID = {
  dzen: IconSocialDzen24,
  facebook: IconSocialFacebook24,
  google: IconSocialGoogle24,
  instagram: IconSocialInstagram24,
  max: IconSocialMax24,
  ok: IconSocialOK24,
  telegram: IconSocialTelegram24,
  vk: IconSocialVK24,
  vk_video: IconSocialVKVideo24,
  youtube: IconSocialYoutube24,
} as const satisfies Record<TSocialId, TSocialIconComponent>;

/** Иконки для узких экранов (совпадают по ключам с `SOCIAL_ICON_BY_ID`). */
export const SOCIAL_ICON_PHONE_BY_ID = {
  dzen: IconSocialDzen16,
  facebook: IconSocialFacebook16,
  google: IconSocialGoogle16,
  instagram: IconSocialInstagram16,
  max: IconSocialMax16,
  ok: IconSocialOK16,
  telegram: IconSocialTelegram16,
  vk: IconSocialVK16,
  vk_video: IconSocialVKVideo16,
  youtube: IconSocialYoutube16,
} as const satisfies Record<TSocialId, TSocialIconComponent>;
